import { clearUrl } from '@elfsight/widget-utils';
import type { AudioItem, Source } from '../../../../types';
import { removeFileExtension } from '../../../helpers';

export function player(source: Source) {
  if (!Array.isArray(source)) {
    return;
  }

  return new Promise<(AudioItem | null)[]>((resolve) => {
    const result = source
      .map(
        ({
          id,
          link,
          image,
          title,
          author = '',
          sourceType,
          buttons,
          duration,
          peaks,
          _trackPeaksSettings
        }) => {
          if (typeof link === 'string') {
            return null;
          }

          const { url, name: filename } = link;
          const { url: imageUrl } = image ?? {};

          if (!url) {
            return null;
          }

          return {
            id,
            buttons,
            author,
            duration,
            image: imageUrl,
            link: url,
            sourceType,
            title:
              title || removeFileExtension(filename) || clearUrl(url) || '',
            peaks,
            _trackPeaksSettings
          };
        }
      )
      .filter(Boolean);

    resolve(result);
  });
}
